import { SVGProps } from 'react';

export default function Creators(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity={0.8}
        fill="currentColor"
        d="M6.079 6.078h4.053v4.053H6.079z"
      />
      <path
        opacity={0.4}
        fill="currentColor"
        d="M6.079 11.867h4.053v4.053H6.079z"
      />
      <path
        opacity={0.6}
        fill="currentColor"
        d="M11.868 6.078h4.053v4.053h-4.053z"
      />
      <path
        opacity={0.2}
        fill="currentColor"
        d="M11.868 11.867h4.053v4.053h-4.053z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.105 0H0v22h22V0h-2.895zm0 2.895H2.895v16.21h16.21V2.895z"
        fill="currentColor"
      />
    </svg>
  );
}
